import '../styles/Header.css'
import Hamburger from 'hamburger-react'
import logo from '../assets/code.svg'

const Header = ({handleBurger, isOpen, setIsOpen}) => {

  return (
    <header>
      <div className='hamburger-name'>
        <Hamburger toggled={isOpen} toggle={
          () => {
            setIsOpen(!isOpen)
            handleBurger(!isOpen)
          }
        }/>
        <p className='app-name'>Vision Simulator</p>
      </div>
      <p className='name'>
        <span>
          <img src={logo} alt="Angle Brackets" />
        </span>
        CodeTesco
      </p>
    </header>
  )
}

export default Header